// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"IdentityLoader_loadingContainer__xR97x","loadingImage":"IdentityLoader_loadingImage__Cn7II"};